import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';
import { ButtonToolbar } from 'react-bootstrap';
import { ContextMenu, Icon } from 'components';
import { formatTimestampForList } from '../../../../../../modules/datetime';
import Button from '../../../../../../modules/react/components/stateless/Button';
import Container from '../../containers/Container';
import SettingsModal from '../../containers/SettingsModal';
import classes from './List.scss';
import gql from 'graphql-tag';

class List extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    posts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      category: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
      date: PropTypes.string.isRequired,
    })),
    onDelete: PropTypes.func.isRequired,
  };

  state = {
    showModal: false,
  };

  handlePostEdit = (id) => {
    browserHistory.push(`/admin/blog/edit/${id}`);
  };

  handlePostDelete = (id) => {
    this.props.onDelete({ variables: { id } });
  };

  hideSettingsModal = () => {
    this.setState({ showModal: false });
  };

  showSettingsModal = () => {
    this.setState({ showModal: true });
  };

  renderPosts(posts) {
    if (!posts.length) {
      return (
        <tr>
          <td colSpan={5}>
            There are no posts. <Link to="/admin/blog/new">Click here</Link> to create a blog post.
          </td>
        </tr>
      );
    }

    return posts.map(post => (
      <tr key={post.id}>
        <td>{post.title}</td>
        <td>{post.author || '—'}</td>
        <td>{post.category?.name || ''}</td>
        <td><span>{formatTimestampForList(post.date)}</span></td>
        <td className={classes.actions}>
          <ContextMenu
            id={post.id}
            heading="Blog Post"
            menuItems={[
              {
                label: 'Edit',
                action: this.handlePostEdit,
                iconClass: 'pencil',
                data: post.id,
              },
              {
                label: 'Delete',
                action: this.handlePostDelete,
                iconClass: 'trash',
                data: post.id,
              },
            ]}
            clearFix={false}
          >
            <Icon icon="settings" />
          </ContextMenu>
        </td>
      </tr>
    ));
  }

  render() {
    const { isLoading, posts } = this.props;
    const { showModal } = this.state;

    if (isLoading) {
      return (
        <Container>
          Loading...
        </Container>
      );
    }
    if (!posts) {
      return (
        <Container>
          Could not load posts
        </Container>
      );
    }

    return (
      <Container>
        <ButtonToolbar key="create-row" className={classes.buttonBar}>
          <Button variant="primary" className="btn-info" as={Link} to="/admin/blog/new">
            <Icon icon="add" /> Create New
          </Button>
          <Button variant="primary" className="btn-success" onClick={this.showSettingsModal}>
            <Icon icon="settings" /> Blog Settings
          </Button>
          <SettingsModal show={showModal} hideSettingsModal={this.hideSettingsModal} />
        </ButtonToolbar>
        <table className={classes.postTable} key="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Author</th>
              <th>Category</th>
              <th colSpan={2}>Date</th>
            </tr>
          </thead>
          <tbody>
            {this.renderPosts(posts)}
          </tbody>
        </table>
      </Container>
    );
  }
}

List.fragments = {
  posts: gql`
    fragment BlogPostData on BlogPost {
      title
      author
      category {
        id
        name
      }
      date
    }
  `,
};

export default List;
